module.exports = __webpack_public_path__ + "media/images/country_flags/lu-1c464134ad710e9747b84d0c57dccd38.png";